import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { isDark, parseToHsl } from '../../helper/ColorUtils';
import { getSwatchColor } from '../../reducers/patterns';

import ColorPicker from './ColorPicker';
import Icon from '../Icon';

const StyledIcon = styled(Icon)`
    background-color: #EEEEEE;
    box-shadow: 0 0 .15em rgba(0, 0, 0, .3), 0 .3em .5em rgba(0, 0, 0, .3);
`;

const Popover = styled.div`
    position: absolute;
    z-index: 4;
`;
const Cover = styled.div`
    position: fixed;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    background: transparent;
`;

const Flex = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`

const Box = styled.div`
    margin: 0 auto;
`

const ColorSwatch = ({ color, id, selected, onClickSelected, onClick }) => {
    const showPicker = selected;

    const shadowInactive = '0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2);';
    const shadowActive = '0 8px 8px 0 rgba(0,0,0,0.3), 0 4px 8px 0 rgba(0,0,0,0.2), 0 3px 1px -1px rgba(0,0,0,0.2);';
    const Swatch = styled.div`
        background-color: ${color};
        border: 2px;
        box-sizing: border-box;
        box-shadow: ${selected ? shadowActive : shadowInactive};
        border-radius: ${props => `${props.theme.radius}px`};
        cursor: pointer;
        color: ${props => isDark(color) ?
        props.theme.palette.common.lightWhite :
        props.theme.palette.common.minBlack};
        position: relative;
        padding: ${props => props.theme.space[3]};
        padding-top: ${props => props.theme.space[2]};
        z-index: 3;
        text-transform: uppercase;
        text-align: center;
        transition: border-box .3s;
        transition: box-shadow 150ms ease-in;
        
        &:hover {
          box-shadow: 0 6px 6px 0 rgba(0,0,0,0.14), 0 3px 7px 0 rgba(0,0,0,0.12), 0 3px 1px -1px rgba(0,0,0,0.2);
        }
        
        &:active {
          box-shadow: ${shadowActive};
        }
    `;

    const handleClick = event =>
        selected ? onClickSelected(event) : onClick(event);

    return (
        <div >
            <Swatch
                data-swatch-id={id} data-swatch-color={color}
                onClick={handleClick}
            >
                {color}
            </Swatch >

            {showPicker ? <Popover >
                <Cover onClick={onClickSelected} />
                <Flex >
                    <ColorPicker />
                    <Box ml='auto' >
                        <StyledIcon name='icon-close' width='1.6em' height='1.6em' />
                    </Box >
                </Flex >

            </Popover > : null}
        </div >
    );
};

const mapStateToProps = (state, ownProps) => {
    const { patternid } = state.location.payload;
    const color = getSwatchColor(state, patternid, ownProps.id);
    return {
        id: ownProps.id,
        color,
        selected: state.stolo.ui.recoloring.activeColorSwatch === ownProps.id,
        onClick: ownProps.onClick,
        onClickSelected: ownProps.onClickSelected,
    };
};

const makeMapStateToProps = (initialState, initialOwnProps) => {
    const { patternid, id, onClick, onClickSelected } = initialOwnProps;
    const mapStateToProps = state => {
        const color = getSwatchColor(state, patternid, id);
        return {
            id,
            color,
            selected: state.stolo.ui.recoloring.activeColorSwatch === id,
            onClick,
            onClickSelected,
        };
    };
    return mapStateToProps;
};

export default connect(mapStateToProps)(ColorSwatch);



// WEBPACK FOOTER //
// ./src/components/recoloring/ColorSwatch.js